module.exports = "/static/assets/fb356e819d8ab210a241ce81b9bac33c.png";